<rt-dialog-header
  [heading]="'tlc.positions.skills_ideate_flow.options.heading' | translate"
  [subheading]="'tlc.positions.skills_ideate_flow.options.subheading' | translate"
/>

<rt-dialog-body variant="white">
  <div class="loading-status-container">
    <rt-spinner />
    <span class="status">{{ 'tlc.positions.skills_ideate_flow.loading.status' | translate }}</span>
    <span class="description">{{
      'tlc.positions.skills_ideate_flow.loading.description' | translate
    }}</span>
  </div>
  <rt-loading-game-frame
    [startText]="gameStartText"
    [tutorialText]="gameTutorialText"
    [gameOverText]="gameOverText"
    [scoreText]="gameScoreText"
  />
</rt-dialog-body>
